<mat-card class="full-height-container">
  <div style="display: flex; justify-content: flex-end; padding: 8px 16px;">
    <button mat-stroked-button type="button" (click)="toggleShowClosedAndDeleted()">
      <mat-icon>{{ showClosedAndDeleted ? 'visibility_off' : 'visibility' }}</mat-icon>
      {{ (showClosedAndDeleted ? 'dataManagement.dataExchangeRequests.hideClosedDeleted' : 'dataManagement.dataExchangeRequests.showClosedDeleted') | transloco }}
    </button>
  </div>
  <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)" class="full-height-container">

    <mat-tab label="{{ 'dataManagement.dataExchangeRequests.tabSent' | transloco }}">
      <div class="tab-container">
        <app-data-exchange-request-table
          [dataSource]="sentDataSource"
          [isReceived]="false"
          [displayedColumns]="displayedColumns"
          [systemColumns]="systemColumns"
          [unitColumns]="unitColumns"
          [componentColumns]="componentColumns"
          [materialColumns]="materialColumns"
          (dataReloadRequired)="loadData()">
        </app-data-exchange-request-table>

        <ng-container *ngIf="showClosedAndDeleted">
          <div class="deleted-section-title">
            {{ 'dataManagement.dataExchangeRequests.closedDeletedSectionTitle' | transloco }}
          </div>

          <div class="deleted-loading" *ngIf="closedSentLoading">
            <mat-spinner diameter="40" color="accent"></mat-spinner>
          </div>

          <app-data-exchange-request-table
            *ngIf="!closedSentLoading"
            [dataSource]="closedSentDataSource"
            [isReceived]="false"
            [displayedColumns]="displayedColumns"
            [systemColumns]="systemColumns"
            [unitColumns]="unitColumns"
            [componentColumns]="componentColumns"
            [materialColumns]="materialColumns"
            (dataReloadRequired)="loadData()">
          </app-data-exchange-request-table>
        </ng-container>
      </div>
    </mat-tab>

    <mat-tab label="{{ 'dataManagement.dataExchangeRequests.tabReceived' | transloco }}">
      <div class="tab-container">
        <app-data-exchange-request-table
          [dataSource]="receivedDataSource"
          [isReceived]="true"
          [displayedColumns]="displayedColumns"
          [systemColumns]="systemColumnsReceived"
          [unitColumns]="unitColumnsReceived"
          [componentColumns]="componentColumnsReceived"
          [materialColumns]="materialColumnsReceived"
          (dataReloadRequired)="loadData()">
        </app-data-exchange-request-table>

        <ng-container *ngIf="showClosedAndDeleted">
          <div class="deleted-section-title">
            {{ 'dataManagement.dataExchangeRequests.closedDeletedSectionTitle' | transloco }}
          </div>

          <div class="deleted-loading" *ngIf="closedReceivedLoading">
            <mat-spinner diameter="40" color="accent"></mat-spinner>
          </div>

          <app-data-exchange-request-table
            *ngIf="!closedReceivedLoading"
            [dataSource]="closedReceivedDataSource"
            [isReceived]="true"
            [displayedColumns]="displayedColumns"
            [systemColumns]="systemColumnsReceived"
            [unitColumns]="unitColumnsReceived"
            [componentColumns]="componentColumnsReceived"
            [materialColumns]="materialColumnsReceived"
            (dataReloadRequired)="loadData()">
          </app-data-exchange-request-table>
        </ng-container>
      </div>
    </mat-tab>

  </mat-tab-group>
</mat-card>
